import { PaywallSubscriptionBadge } from "@circle-react-shared/Paywalls/PaywallSubscriptionBadge";

export const StatusColumn = (cellContext: any) => {
  const {
    row: { original: subscription },
  } = cellContext;

  return <PaywallSubscriptionBadge subscription={subscription} />;
};
